import { useSEO } from "../components/SEO";
import { PageHero } from "../components/Reveal";
import { PricingCards } from "../components/PricingCards";
import { PackageExplainer } from "../components/PackageExplainer";
import { OneTimeServices } from "../components/OneTimeServices";
import { FeeTransparency } from "../components/FeeTransparency";
import { CtaBand } from "../components/CtaBand";

export default function Pricing() {
  useSEO(
    "Hajj & Umrah Marketing Agency Pricing India | Nexus Catalyst",
    "Transparent pricing in ₹ INR for specialized Hajj & Umrah growth marketing: Foundation, Growth and Scale retainers, one-time website development and content production days for Indian travel agencies."
  );

  return (
    <main data-testid="pricing-page">
      <PageHero
        tag="Pricing"
        testid="pricing-hero"
        crumbs={[{ label: "Pricing", to: "/pricing" }]}
        lines={[
          "Choose the right level of",
          <>marketing <span className="text-tan">support.</span></>,
        ]}
        copy="Transparent pricing, in rupees. Monthly retainers for ongoing growth, one-time projects for websites and content. Nothing is billed until it's agreed."
      />
      <PricingCards showNotes />
      <PackageExplainer />
      <OneTimeServices />
      <FeeTransparency />
      <CtaBand
        title="Let's Find the Right Scope for Your Agency."
        copy="Book a strategy call and we'll recommend a level honestly, including telling you if a smaller scope is enough."
        testid="pricing-cta-band"
      />
    </main>
  );
}
